import {
    getAPIGatewayPostRequest,
    getNodeId, isResponseCode5xx,
    logOperationalMetric,
} from "../../../util/Util";
import {
    ENDPOINT_GET_LED_CONTROLLERS,
    LED_CONTROLLER_ASSET_TYPE,
    LOADING_FAILED,
    ENDPOINT_UPDATE_DISABLE_MONITORING_SCHEDULE,
    ALERT_UPDATE_ASSET_MESSAGE, ENDPOINT_UPDATE_LED_CONTROLLERS_REMARKS
} from "../../../util/Constants";
import {getSiteDevicesConnectivity} from "../../../resources/AssetResource";
import {getAPIGatewayDataFromParent} from "../../../handler/ParentDataHandler";
import {PATTERNS} from "../../../util/Validations";
export const metricProcessName = "LED_CONTROLLER_DEVICE_DETAILS";

export const extractLedControllerDeviceList = (nodeId, result, ledControllersConnectivity) => {
    const model = {
        ledControllerDeviceInformation: {},
    }
    if (result.status === 200 && result.data.ledControllerList) {
        result.data.ledControllerList.forEach((ledControllerDeviceDetail) => {
            const detail = ledControllersConnectivity[ledControllerDeviceDetail.mac];
            model.ledControllerDeviceInformation[ledControllerDeviceDetail.mac] = {
                mac: ledControllerDeviceDetail.mac,
                ip: ledControllerDeviceDetail.ip,
                connectivity: detail ? detail.status : LOADING_FAILED,
                timestamp: detail ? detail.lastUpdateTime : "",
                location: ledControllerDeviceDetail.location ? ledControllerDeviceDetail.location : "Not Configured",
                startTime: ledControllerDeviceDetail.disableMonitoring ? ledControllerDeviceDetail.disableMonitoring.startTime : "0",
                endTime: ledControllerDeviceDetail.disableMonitoring ? ledControllerDeviceDetail.disableMonitoring.endTime : "0",
                reason: ledControllerDeviceDetail.disableMonitoring ? ledControllerDeviceDetail.disableMonitoring.reason : "",
                remarks: ledControllerDeviceDetail.remarks ? ledControllerDeviceDetail.remarks : ""
            }
        });
    }
    return model;
}


export async function getLedControllerDeviceStatusDetails(dispatcher) {
    const request = {
        nodeId: getNodeId()
    }
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_LED_CONTROLLERS);
    let model = {};
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "getLedControllerDeviceStatusDetails", true, false);
        const ledControllersConnectivity = await getLEDControllersConnectivity(request.nodeId, response);
        model = extractLedControllerDeviceList(request.nodeId, response, ledControllersConnectivity);
        dispatcher({type: "RECEIVE_DATA", data: model});
    } else {
        const isFault = isResponseCode5xx(response.status)
        logOperationalMetric(startTime, metricProcessName, "getLedControllerDeviceStatusDetails", false, isFault);
        dispatcher({type: "RECEIVE_DATA", data: model});
    }
}

async function getLEDControllersConnectivity(nodeId, result) {
   const deviceIdentifierList = [];
   let ledControllersConnectivity = {};
    if (result.data && result.data.ledControllerList) {
        result.data.ledControllerList.forEach((ledControllerDeviceDetail) => {
            deviceIdentifierList.push(ledControllerDeviceDetail.mac);
        });
    }
    if (deviceIdentifierList && deviceIdentifierList.length > 0) {
        ledControllersConnectivity = await getSiteDevicesConnectivity(nodeId, LED_CONTROLLER_ASSET_TYPE);
    }
    const ledControllerConnectivityMap = {}
    if (ledControllersConnectivity.status === 200 && ledControllersConnectivity.data.deviceConnectivityList) {
        ledControllersConnectivity.data.deviceConnectivityList.forEach(connectivity => {
            const identifier = connectivity.identifier.match(PATTERNS.MAC_MASK)[0];
            ledControllerConnectivityMap[identifier] = connectivity;
        })
    }
    return ledControllerConnectivityMap;
}

export async function setLEDControllerDisableMonitoringData(dispatch, stateValues, mac) {
    const request = {
        nodeId: getNodeId(),
        macAddress: mac,
        startTime: stateValues.startTime,
        endTime: stateValues.endTime,
        reason: stateValues.reason
    }
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_UPDATE_DISABLE_MONITORING_SCHEDULE);
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "updateLEDControllerDisableMonitoringSchedule", true, false);
        setTimeout(async()=> {
            await getLedControllerDeviceStatusDetails(dispatch);
            dispatch({type: 'SET_MONITORING_STATUS_LOADER', data: {mac: mac, monitoringStatusLoading: false}})
        },30000);
    } else {
        const isFault = isResponseCode5xx(response.status)
        logOperationalMetric(startTime, metricProcessName, "updateLEDControllerDisableMonitoringSchedule", false, isFault);
    }
}

export async function postUpdatedRemarkToDevice(device, newRemark, dispatch) {
    const request = {
        nodeId : getNodeId(),
        macAddress: device.mac,
        remarks: newRemark
    }
    const args = getAPIGatewayPostRequest(request, ENDPOINT_UPDATE_LED_CONTROLLERS_REMARKS);
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status !== 200) {
        alert(ALERT_UPDATE_ASSET_MESSAGE);
        dispatch({type: 'LOAD_VIEW', data: {dispatcher: dispatch}});
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/network/LEDControllerOverviewNetworkAPI.js